import { render, staticRenderFns } from "./AveragesView.vue?vue&type=template&id=6d0f8d97&"
import script from "./AveragesView.vue?vue&type=script&lang=js&"
export * from "./AveragesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports